import WebChat from './webchat'
import '../style/tailwind.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'preact/hooks'
import { AppContextProvider } from '../contexts/app-context'

const App = () => {
  const [queryClient] = useState(() =>
    new QueryClient({
      defaultOptions: {
        queries: {
          suspense: false,
        }
      }
    })
  )

  return (
    <div id="app">
      <QueryClientProvider client={queryClient}>
        <AppContextProvider>
          <WebChat />
        </AppContextProvider>
      </QueryClientProvider>
    </div>
  )
}

export default App
